import { HTMLAttributes } from 'react';

export namespace ThankYouPageTypes {
  type ConfirmationDetails = {
    label: string;
    value: string;
  };
  export interface IThankYouPage extends HTMLAttributes<HTMLDivElement> {
    completionMessage: string;
    thankYouMessage: string;
    contactMessage: string;
    queryMessage: string;
    confirmationDetails: ConfirmationDetails[];
    eSignToken: string;
    receipt_url: string;
  }
}
